import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import {injectIntl} from '@s7ui-kit/s7ui-kit';
import requestUtil from "../../../services/services/requestUtil";

import pushGA from "../../../services/utils/pushGA";

import { analyticsBannerClick, analyticsBannerLoad, analyticsBannerShow } from '../../../services/analytics/analyticsBanners';
import '../new-mainpage/application-vertical-place.scss';

const mapStateToProps = ({App, User}) => ({App, User});

let alreadyShowned = false;

const ApplicationVerticalPlace = (props) => {
    const {App: {lang}} = props;

    const [ title, setTitle ] = useState();
    const [ text, setText ] = useState();
    const [ link, setLink ] = useState();
    const [ linkText, setLinkText ] = useState();
    const [ gotBanner, setGotBanner ] = useState(false);
    const [ isCommon, setIsCommon ] = useState(false);
    const [ type, setType ] = useState('Common');
    const [ image, setImage ] = useState(null);
    const [ bgColor, setBgColor ] = useState('');
    const [ textColor, setTextColor ] = useState('');
    const [ titleColor, setTitleColor ] = useState('');
    const [ stylesContainer, setStylesContainer ] = useState({});
    const [ stylesTitle, setStylesTitle ] = useState({});
    const [ stylesText, setStylesText ] = useState({});
    const [ code, setCode ] = useState('');

    let ApplicationVerticalPlace = useRef(null);

    useEffect(() => {
        const searchParams = new URLSearchParams('');
        searchParams.append('lang', lang);
        searchParams.append('ns', 'default');
        searchParams.append('place', 'MOBILE_APP_PLACE');

        requestUtil(`/S7WAdsService/api/v1/recommendation/diamonds?${searchParams}`).then((response) => {
            if ( response.length > 0 ) {
                const {image, link, linkText, title, content, settings, code} = response[0];

                const {
                    bgColor,
                    custom,
                    textColor,
                    titleColor
                } = settings;

                const {stylesContainer, stylesTitle, stylesText} = custom;

                setTitle(title);
                setImage(image);
                setText(content);
                setLink(link);
                setLinkText(linkText);
                setGotBanner(true);
                setBgColor(bgColor);
                setTextColor(textColor);
                setTitleColor(titleColor);
                if(stylesContainer) setStylesContainer(stylesContainer);
                if(stylesText) setStylesText(stylesText);
                if(stylesTitle) setStylesTitle(stylesTitle);
                if(code) setCode(code);

                const callback = () =>  {
                    if (alreadyShowned) {
                        return;
                    }

                    alreadyShowned = true;
                    sendGaEvent('Show', code);
                    analyticsBannerShow(ecomParamsForGA(code));
                };

                const options = {
                    rootMargin: '0px',
                    threshold: 1.0
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(ApplicationVerticalPlace);

                sendGaEvent('Load', code);
                if(!!code) {
                    analyticsBannerLoad(ecomParamsForGA(code));
                }
            } else {

            }
        }).catch(() => {

        });
    }, []);

    const ecomParamsForGA = (code) => {
        return [{
            item_id: code || '',
            item_name: 'banner',
            item_variant: 'card',
            location_id: 's7_main',
        }]
    };

    const sendGaEvent = ( label, code ) => {

        if ( isCommon ) {
            setType('Personal');
        }

        pushGA(
            'PORTAL Banners',
            `${type} ${label}`,
            `CONTENT:smallMain;NAME:${code};`,
            { eventValue: 1 },
        );
    };

    return (
        <div
            ref={ref => {
                if (!ref) {
                    return;
                }
                ApplicationVerticalPlace = ref;
            }}
        >
            {
                gotBanner && <div
                    className={'application-vertical-place'}
                    id={'application-vertical-place'}
                    style={{
                        'backgroundColor': bgColor,
                        ...stylesContainer
                    }}
                    onClick={() => {
                        sendGaEvent('click', code);
                        analyticsBannerClick(ecomParamsForGA(code));
                    }}
                >
                    <div>
                        {title && <h2
                            className={'application-vertical-place__title'}
                            style={{
                                color: titleColor,
                                ...stylesTitle
                            }}
                            dangerouslySetInnerHTML={{__html: title}}
                        />}

                        {text && <div
                            className={'application-vertical-place__text'}
                            style={{
                                color: textColor,
                                ...stylesText
                            }}
                            dangerouslySetInnerHTML={{__html: text}}
                        >
                        </div>}
                    </div>

                </div>

            }
        </div>
    );
};


export default injectIntl(connect(mapStateToProps)(React.memo(ApplicationVerticalPlace)));
